<template>
    <div id="BlogList">
        <BigTitle />
        <div class="row">
            <div class="col-2 offset-1">
                <SideBar />
            </div>
            <div class="col-7 offset-1 d-flex flex-column">
                <BlogItem v-for="(item) in blogs" 
                    v-bind:key="item.card" 
                    v-bind:card="item.card" 
                    v-bind:title="item.title" 
                    v-bind:desc="item.desc" 
                    v-bind:timeDesc="item.timeDesc"
                    v-bind:categoryNames="item.categoryNames"
                    v-bind:type="item.type"/>
                <div class="text-center">
                    <b-spinner variant="primary" small label="Text Centered" v-bind:class="isLoadData ? 'visible' : 'invisible'"></b-spinner>
                </div> 
                <div class="alert alert-secondary text-center hidden" v-bind:class="noMoreData ? 'visible' : 'invisible'" role="alert">
                    没有更多了
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import BlogItem from '../components/BlogItem'
import SideBar from '../components/SideBar'
import BigTitle from '../components/BigTitle'
import axios from 'axios'
// import GlobalConstant from '../constants/GlobalConstant'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
    //"el" : "#BlogList",
    "name": "BlogList",
    data: function(){
        return {
            visibleOfThirdLink : false,
            visibleOfCategory : true,
            blogs: [],
            categories : [],
            page: 1,
            pageSize: 8,
            categoryName: "",
            noMoreData : false,
            isLoadData : false
        }
    },
    components: {
        BlogItem,
        SideBar,
        BigTitle
    },
    mounted: function(){
        console.log("mounted!!!!");
        this.categoryName = this.$route.query.name ? this.$route.query.name : "";
        this.setBlogData();
        var _this = this;
        window.onscroll = function(){
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            scrollTop = Math.ceil(scrollTop);
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            //console.log("scrollTop = " + scrollTop + ", windowHeight = " + windowHeight + ", scrollHeight = " + scrollHeight);
            //滚动条到底部的条件
            if(scrollTop+windowHeight >= scrollHeight){
                //到了这个就可以进行业务逻辑加载后台数据了
                if(!_this.noMoreData){
                    _this.page ++;
                    _this.setBlogData();
                }
            }
        }
    },

    methods : {
        setBlogData : function(){
            var _this = this;            
            var blogData = _this.blogs;
            var url = '/api/blog/getMore';
            var query = '?offset=' + (this.page - 1) * this.pageSize + '&size=' + this.pageSize;
            console.log('this.categoryName = ' + this.categoryName);
            if(this.categoryName){
                query = query + '&categoryName=' + this.categoryName;
            }
            _this.isLoadData = true;
            axios.get(url + query)
                .then(function(response){
                    console.log(response)
                    var res = response.data;
                    if(res.code == 1){
                        var data = res.data;
                        if(data.length > 0){
                            data.forEach(element => {
                                var obj = {};
                                obj.card = element.card;
                                obj.title = element.title
                                obj.desc = element.description
                                obj.timeDesc = "更新于 " + element.updateTimeStr;
                                obj.categoryNames = element.categoryNames;
                                obj.type = element.type;
                                blogData.push(obj);
                            });
                            _this.$set(_this, "blogs", blogData);
                        }else{
                            _this.$set(_this, "noMoreData", true);
                        }
                    }else{
                        console.log(res.msg);
                    }
                    _this.$set(_this, "isLoadData", false);
                }).catch(function(error){
                    console.log(error)
                })
        }
    }
}
</script>


<style>
    
</style>